"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconChain = Experimental__IconChain;
exports.IconChain = IconChain;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconChain/index.tsx)
 */
function IconChain(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m9.276 2.888-.998.998a5.571 5.571 0 0 0-1.932-.19l1.87-1.868a4.212 4.212 0 0 1 5.957 5.957l-1.969 1.968a4.212 4.212 0 0 1-6.769-1.138L5.8 8.25a1.38 1.38 0 0 1 .934-.403 2.712 2.712 0 0 0 4.41.845l1.969-1.968a2.712 2.712 0 1 0-3.836-3.836Z\'/><path d=\'m6.724 13.112.998-.998a5.57 5.57 0 0 0 1.932.19l-1.87 1.869a4.212 4.212 0 0 1-5.957-5.958l1.969-1.968a4.212 4.212 0 0 1 6.769 1.138l-.364.365a1.374 1.374 0 0 1-.934.403 2.712 2.712 0 0 0-4.41-.845L2.888 9.276a2.712 2.712 0 1 0 3.836 3.836Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m13.78 4.582-1.469 1.47a8.022 8.022 0 0 0-2.57-.258l2.626-2.626a5.986 5.986 0 0 1 8.465 8.465l-2.835 2.835a5.986 5.986 0 0 1-9.63-1.643l.464-.465c.351-.35.8-.543 1.26-.576a3.986 3.986 0 0 0 6.492 1.27l2.835-2.835a3.986 3.986 0 1 0-5.637-5.637Z\'/><path d=\'m10.22 19.418 1.469-1.47c.84.225 1.708.311 2.57.258l-2.626 2.626a5.986 5.986 0 1 1-8.465-8.466l2.835-2.834a5.986 5.986 0 0 1 9.63 1.643l-.464.464a1.97 1.97 0 0 1-1.26.577 3.986 3.986 0 0 0-6.492-1.27l-2.835 2.835a3.986 3.986 0 1 0 5.637 5.637Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconChain is deprecated and will be archived soon. Use IconChain instead.
 */
function Experimental__IconChain(props) {
  return /*#__PURE__*/_react["default"].createElement(IconChain, props);
}